import BaseService from '@/services/base-service';
import HttpService from './http.service';

export default class Hub360DialogService extends BaseService {
  constructor(httpService: HttpService) {
    super(httpService);
  }

  async generateApiKey(channelId: string): Promise<void> {
    return (await this.httpService.post(
      {} as any,
      `${this.apiUrl}/hub360dialog/generate-api-key/${channelId}`,
      null
    )) as any;
  }
}
